import(/* webpackMode: "eager" */ "/root/hcs_admin/src/app/(auth)/signup/page.tsx");
